import React from "react";
import { Row, Col } from "react-bootstrap";
import "./Component3.css";

const Component3 = ({ title = "Expert Tips", tips = [], list = false }) => {
  return (
    <div className="section_block">
      <Row>
        <Col xs={12}>
          <h3 className="sub_title">{title}</h3>
          <div className="tips_list">
            <p  className="passage">
            {list ? (
              <ul>
                {tips.map((tip, index) => (
                  <li key={index}>{tip}</li>
                ))}
              </ul>
            ) : (
              tips.map((tip, index) => (
                <p key={index} className="passage">
                  {tip}
                </p>
              ))
            )}
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Component3;

